import React, { Component } from 'react';

export default class HeaderLogo extends Component {
    render() {
        return (
            <div className="page-logo">
                <div className="menu-toggler sidebar-toggler">

                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Header/HeaderLogo.js
 **/